import { Component, ContentChild, Input, OnInit, TemplateRef } from '@angular/core';
import { DefaultOptionsListComponent } from '../../default-options-list/default-options-list.component';
import { SELECTED_OPTION } from '../../overlays/option-list.constants';
import { NgScrollbar } from 'ngx-scrollbar';
import { NgClass, NgForOf, NgIf, NgStyle, NgTemplateOutlet } from '@angular/common';
import { IItemTrackingChecklist } from '../../../store/item-tracking/item-tracking.reducer';
import { IChecklist } from '../checklist-input/checklist-input.component';

@Component({
  selector: 'app-checklist-dropdown',
  templateUrl: './checklist-dropdown.component.html',
  styleUrls: ['./checklist-dropdown.component.scss'],
  standalone: true,
  imports: [NgScrollbar, NgForOf, NgIf, NgTemplateOutlet, NgStyle, NgClass],
})
export class ChecklistDropdownComponent extends DefaultOptionsListComponent implements OnInit {
  @ContentChild('projectedContent') projectedContentTemplate: TemplateRef<any>;
  @Input() checkLists: IChecklist[] | IItemTrackingChecklist[] = [];
  @Input() selectedId: number = null;
  @Input() showNoChecklistOption = true;
  @Input() width: any;
  SELECTED_OPTION = SELECTED_OPTION;
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
